import bwhite from '../../../../../assets/media/icons/bwhite.png';
import Row from '../../../../../components/Basic/Blocks/Row';
import Button from '../../../../../components/Basic/Buttons/Button';
import Icon from '../../../../../components/Basic/Elements/Icon';
import { TYPE_BUTTONS } from '../../../../../constans';

const BWhiteContentButton = ({ roleUser = 'content', onClick = (_) => _ }) => {
  return (
    <Row style={{ alignItems: 'flex-end' }}>
      <Button type={TYPE_BUTTONS.WHITE} onClick={() => onClick()}>
        <Icon src={bwhite} width={'25px'} style={{ marginRight: '10px' }} />
        Перенести в b-white
      </Button>
    </Row>
  );
};
export default BWhiteContentButton;
